<template>
  <div>
    <baseEdit status="edit" />
  </div>
</template>

<script>
  import baseEdit from './projectBaseEdit';

  export default {
    name: 'projectEdit',
    components: {
      baseEdit,
    },
  };
</script>
